import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'pl';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ijpcuzwkmx98">
      <div lang="pl" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mlaxj7fckftz">
        <CountdownBar data-id="element-2" data-mp="3rc9i4j7dc031" />
        <main data-id="element-3" data-mp="3rbzomln47asl">
          <Hero data-id="element-4" data-mp="3rdkhm6ts6loc" />
          <StatsBar data-id="element-5" data-mp="3rd1bdndhtlq5" />
          <Difference data-id="element-6" data-mp="3relu8fqg3g86" />
          <Recognize data-id="element-7" data-mp="5opiv1o0k3w" />
          <WhatsInside data-id="element-8" data-mp="4wv3njt0sf7" />
          <InsidePages data-id="element-9" data-mp="5gbv0xpxarn" />
          <Bonuses data-id="element-10" data-mp="7ssnarqpf34" />
          <HowItWorks data-id="element-11" data-mp="2zld259q0hfbj" />
          <Audience data-id="element-12" data-mp="2zm4yimrfnh2v" />
          <Offer data-id="element-13" data-mp="2zmo6bandcp36" />
          <Guarantee data-id="element-14" data-mp="2zn6biws0edn8" />
          <Testimonials data-id="element-15" data-mp="33morde4z3yj7" />
          <Faq data-id="element-16" data-mp="33lwzoeehyky7" />
          <FinalCta data-id="element-17" data-mp="33ngee0ki8nxv" />
        </main>
        <Footer data-id="element-18" data-mp="33oi337ug18y2" />
      </div>
    </MotionConfig>;
}